import { render } from "./dialogFilterCustomers.vue?vue&type=template&id=03061f3f&scoped=true"
import script from "./dialogFilterCustomers.vue?vue&type=script&lang=js"
export * from "./dialogFilterCustomers.vue?vue&type=script&lang=js"

import "./dialogFilterCustomers.vue?vue&type=style&index=0&id=03061f3f&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03061f3f"]])

export default __exports__